import Header from "./Header";
import BestProducts from "./BestProducts";
import ProductsHome from "./Categories";
import AboutHome from "./About";
import "./style.css";
import { useEffect, useState } from "react";
import BannerService from "../../services/BannerService";
import Loading from "../../common/Loading/Loading";
import ProductsService from "../../services/ProductsService";
import CategoriesService from "../../services/CategoriesService";
import Categories from "./Categories";

const Home = () => {
	const [data, setData] = useState({
		header: [],
		categories: [],
		bestProducts: {},
	});
	const [loader, setLoader] = useState(false);
	const bannerService = new BannerService();
	const productsService = new ProductsService();

	useEffect(() => {
		setLoader(true);
		Promise.all([
			bannerService?.getList(),
			new CategoriesService()?.getList({ offset: 0, limit: 4 }),
			productsService?.getList({ offset: 0, limit: 16, bestSeller: true }),
		])
			.then((res) => {
				let info = {};
				if (res[0]?.status === 200 && !!res[0]?.data?.data?.length) {
					info["header"] = res[0]?.data?.data;
				}
				if (res[1]?.status === 200) {
					info["categories"] = res[1]?.data?.data?.data;
				}
				if (res[2]?.status === 200) {
					info["bestProducts"] = res[2]?.data?.data?.data;
				}
				setData(info);
				setLoader(false);
			})
			.catch(() => setLoader(false));
	}, []);

	if (loader) {
		return (
			<div className="loading-page">
				<Loading />
			</div>
		);
	}
	return (
		<>
			<Header data={data?.header} />
			<Categories data={data?.categories} />
			<BestProducts data={data?.bestProducts} />
			{/* <AboutHome /> */}
		</>
	);
};
export default Home;
